<template>
  <div class="container-fluid">
      <p style="position:relative;left:-10px"><b>Certificaciones</b></p>
      <div class="row pt-2 pb-2 cuerpo_cert">
          
          <div class="col-sm-4">
            <p v-if="cert1_val == 1" class="text-center"> 
                <span class="badge badge-success">
                  <i> <font-icon class="icon" icon="check"/> </i>
                </span>
                <small> <i> Verificado </i> </small>
            </p>
            <p v-else class="text-center"> 
                <span class="badge badge-danger">
                  <i> <font-icon class="icon" icon="times"/> </i>
                </span>
                <small> <i> No Verificado </i> </small>
            </p>
            <p class="text-center">
                <a :href="cert1" target="_blank" v-if="cert_nom1">
                  <span>{{cert_nom1}}</span>
                </a>
                <span v-else> -- </span>
            </p>
          </div>
          
          <div class="col-sm-4">
            <p v-if="cert2_val == 1" class="text-center">
                <span class="badge badge-success">
                  <i> <font-icon class="icon" icon="check"/> </i>
                </span>
                <small> <i> Verificado </i> </small> 
            </p>
            <p v-else class="text-center"> 
              <span class="badge badge-danger">
                <i> <font-icon class="icon" icon="times"/> </i>
              </span>
              <small> <i> No Verificado </i> </small>
            </p>
              <p class="text-center">
                <a :href="cert2" target="_blank" v-if="cert_nom2">
                  <span>{{cert_nom2}}</span>
                </a>
                <span v-else> -- </span>
              </p>
          </div>
          
          <div class="col-sm-4">
            <p v-if="cert3_val == 1" class="text-center">
                <span class="badge badge-success">
                  <i> <font-icon class="icon" icon="check"/> </i>
                </span>
                <small> <i> Verificado </i> </small> 
              </p>
              <p class="text-center" v-else> 
                <span class="badge badge-danger">
                  <i> <font-icon class="icon" icon="times"/> </i>
                </span>
                <small> <i> No Verificado </i> </small>
              </p>
              <p class="text-center">
                <a :href="cert3" target="_blank" v-if="cert_nom3">
                  <span>{{cert_nom3}}</span>
                </a>
                <span v-else> -- </span>
              </p>
          </div>

      </div>
  </div>
</template>

<script>
export default {
name: 'Certificaciones',
props:['cert1','cert2', 'cert3','cert1_val','cert2_val','cert3_val','cert_nom1','cert_nom2','cert_nom3'],
data () {
     return { }
    },
}
</script>

<style>
.cuerpo_cert{
  border: 1px solid blue;
  height: 140px;
}
</style>


// WEBPACK FOOTER //
// src/components/Certificaciones.vue